import { ImmomioButtonComponent } from '@immomio/ui/button';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalComponent } from '../../../components/legacy/modal/modal.component';
import { ModalContentComponent } from '../../../components/legacy/modal/modal-content/modal-content.component';
import { ModalFooterComponent } from '../../../components/legacy/modal/modal-footer/modal-footer.component';

@Component({
  selector: 'app-downgrade-modal',
  templateUrl: './downgrade-modal.component.html',
  styleUrls: ['./downgrade-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ImmomioButtonComponent,
    TranslatePipe,
    ModalComponent,
    ModalContentComponent,
    ModalFooterComponent
  ]
})
export class DowngradeModalComponent {
  private ngbActiveModal = inject(NgbActiveModal);

  close() {
    this.ngbActiveModal.close();
  }

  dismiss() {
    this.ngbActiveModal.dismiss();
  }
}
